import { toDate, type DateLike } from './parse.js';
import { getResolvedLocale, getResolvedTimezone } from './localize.js';

export interface FormatDateOptions extends Intl.DateTimeFormatOptions {
  locale?: string;
}

function resolve(opts: FormatDateOptions = {}): { locale: string; format: Intl.DateTimeFormatOptions } {
  const { locale, ...rest } = opts;
  const tz = rest.timeZone ?? getResolvedTimezone();
  return {
    locale: locale ?? getResolvedLocale(),
    format: { ...rest, timeZone: tz }
  };
}

export function formatDate(input: DateLike, opts: FormatDateOptions = {}): string {
  const { locale, format } = resolve({ year: 'numeric', month: 'short', day: 'numeric', ...opts });
  return new Intl.DateTimeFormat(locale, format).format(toDate(input));
}

export function formatTime(input: DateLike, opts: FormatDateOptions = {}): string {
  const { locale, format } = resolve({ hour: '2-digit', minute: '2-digit', ...opts });
  return new Intl.DateTimeFormat(locale, format).format(toDate(input));
}

export function formatDateTime(input: DateLike, opts: FormatDateOptions = {}): string {
  const { locale, format } = resolve({
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...opts
  });
  return new Intl.DateTimeFormat(locale, format).format(toDate(input));
}

export function formatIso(input: DateLike): string {
  return toDate(input).toISOString();
}
